import { DEFAULT_STREAM_BIND_MODAL_STATE } from './consts';
import { StreamBindModalAction, StreamBindModalActionTypes, StreamBindModalState } from './types';

export const streamBindModalReducer = (
  state: StreamBindModalState,
  action: StreamBindModalAction
): StreamBindModalState => {
  switch (action.type) {
    case StreamBindModalActionTypes.SET_SELECTED_POINTS: {
      return {
        ...state,
        selectedPoints: action.selectedPoints,
      };
    }
    case StreamBindModalActionTypes.SET_DISABLED_POINTS: {
      return {
        ...state,
        disabledPoints: action.disabledPoints,
      };
    }
    case StreamBindModalActionTypes.SET_SEARCH_TEXT: {
      return {
        ...state,
        searchText: action.searchText,
      };
    }
    case StreamBindModalActionTypes.SET_IS_BIND_LOADING: {
      return {
        ...state,
        isBindLoading: action.isBindLoading,
      };
    }
    case StreamBindModalActionTypes.RESET_STATE: {
      return {
        ...state,
        ...DEFAULT_STREAM_BIND_MODAL_STATE,
      };
    }
    default:
      return state;
  }
};
